import React from 'react';
import ReviewsContentFilterInput from '@app/model/review/input/ReviewsContentFilterInput';
import MenuButtonFilter from '@app/component/menu/MenuButtonFilter';
import ReviewsFilterInput from '@app/model/review/input/ReviewsFilterInput';

type ReviewContentButtonFilterProps = {
	filter: ReviewsFilterInput;
	onFilter: (filter: ReviewsFilterInput) => void;
};

const ReviewsContentButtonFilter = React.memo(
	function ReviewsContentButtonFilter({ filter, onFilter }: ReviewContentButtonFilterProps) {

		const menuItems = [
			{
				value: ReviewsContentFilterInput.ALL,
				name: 'All Reviews',
			},
			{
				value: ReviewsContentFilterInput.ONLY_TEXT,
				name: 'Reviews with text',
			},
		];

		const onSelect = (value: ReviewsContentFilterInput) => {
			onFilter({
				...filter,
				content: value,
			});
		};

		return <MenuButtonFilter menuItems={menuItems} selectedValue={filter.content} onSelect={onSelect} />;
	},
);

export default ReviewsContentButtonFilter;